import React from 'react';

/**
 * MatchmakingButton
 *
 * Circular LRB logo button that triggers AI-powered tutor matchmaking.
 * Appears in the student roster for unassigned students (admin only).
 */
const MatchmakingButton = ({ onClick, disabled = false, isLoading = false }) => {
  return (
    <button
      className={`matchmaking-button ${isLoading ? 'matchmaking-button--loading' : ''}`}
      onClick={onClick}
      disabled={disabled || isLoading}
      aria-label="Find best tutor match"
      title="Find best tutor match"
    >
      {isLoading ? (
        <div className="matchmaking-button__spinner" />
      ) : (
        <img
          src="/lrbrain-logo.png"
          alt=""
          className="matchmaking-button__logo"
        />
      )}
    </button>
  );
};

export default MatchmakingButton;
